import { useState } from "react";
import api from "../services/api";

export default function ManagerLoginModal({ onSuccess, onClose }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async () => {
    if (!username || !password) {
      alert("Enter username and password");
      return;
    }

    try {
      setLoading(true);

      const res = await api.post("/auth/manager-login", {
        username: username.trim(),
        password
      });

      localStorage.setItem("manager_token", res.data.token);

      setUsername("");
      setPassword("");

      onSuccess();   // ✅ only verify
    } catch {
      alert("Invalid manager credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h3>Manager Authorization</h3>

        <input
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          disabled={loading}
        />

        <br /><br />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={loading}
        />

        <br /><br />

        <button onClick={login} disabled={loading}>
          {loading ? "Verifying..." : "Authorize"}
        </button>

        <button onClick={onClose} style={{ marginLeft: 10 }}>
          Cancel
        </button>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000
};

const modal = {
  background: "#fff",
  padding: 20,
  width: 320,
  borderRadius: 6
};
